import { render, staticRenderFns } from "./TrademarkObjection.vue?vue&type=template&id=69dac5a8&scoped=true"
import script from "./TrademarkObjection.vue?vue&type=script&lang=js"
export * from "./TrademarkObjection.vue?vue&type=script&lang=js"
import style0 from "./TrademarkObjection.vue?vue&type=style&index=0&id=69dac5a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69dac5a8",
  null
  
)

export default component.exports